import React, { Component } from 'react';
import { Row, Col, Form, FormGroup, Label } from 'reactstrap';
import BarCodeUtil from '../../../../../../app/common/util/barcode.util';

class EtiquetaCassetePrintContainer extends Component {
  render () {
    return (
      <div className='mv-etiqueta-container' style={{ margin: '50px' }}>
        <Row>
          {this.props.selecionados.map(id => {
            const indice = this.props.blocos.findIndex(b => b.id === id);
            const bloco = this.props.blocos.slice(indice, indice + 1)[0];

            return (
              <div
                key={bloco.id}
                className='mv-item-etiqueta'
                style={{ margin: '10px' }}
              >
                <Row>
                  <Col>
                    <div>
                      <BarCodeUtil
                        id={bloco.id}
                        texto={`${bloco.numeroBloco}`}
                      />
                    </div>
                  </Col>
                </Row>
                <Row>
                  <Col style={{ textAlign: 'center' }}>
                    <Form>
                      <FormGroup row>
                        <Label sm={4}>{bloco.numeroBloco}</Label>
                        <Label style={{ fontSize: '16px' }} sm={4}>
                          {this.props.nrExame}
                        </Label>
                      </FormGroup>                     
                    </Form>
                  </Col>
                </Row>
              </div>
            );
          })}
        </Row>
      </div>
    );
  }
}

export default EtiquetaCassetePrintContainer;



// WEBPACK FOOTER //
// ./src/pages/laudo/etapas/macroscopia/operacoes/etiqueta/etiqueta.print.container.js